import React, { useContext, useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { userContext } from "../../Contexts/userContext";
import AddSession from "../../Templates/Sessions/AddSession/AddSession";
import { classesURL } from "../../Hooks/URL";
import useFetch from "../../Hooks/useFetch";
import useFetchWhen from "../../Hooks/useFetchWhen";

function AddSessionPage({ Edit = false }) {
  const { contextData } = useContext(userContext);
  const { id, session_id } = useParams();
  const navigate = useNavigate();
  const [session, setSession] = useState(null);
  const [Class, setClass] = useState(null);

  const {
    data: classData,
    loading: classLoading,
    error: classError,
  } = useFetch(`${classesURL}/${id}`);
  const {
    data: sessionData,
    loading: sessionLoading,
    error: sessionError,
  } = useFetchWhen(`${classesURL}/${id}/sessions/${session_id}`, Edit);

  useEffect(() => {
    if (!classLoading && !classError && classData) {
      setClass(classData?.data);
    }
  }, [classData, classLoading, classError]);

  useEffect(() => {
    if (!sessionLoading && !sessionError && sessionData) {
      setSession(sessionData?.data);
    }
  }, [sessionData, sessionLoading, sessionError]);

  return (
    <AddSession
      Class={Class}
      loading={classLoading}
      contextData={contextData}
      Edit={Edit}
      session={session}
    />
  );
}

export default AddSessionPage;
